<mat-tab-group>
    <mat-tab label="College Contacts">
        <app-college-contact></app-college-contact>
    </mat-tab>
    <mat-tab label="Email Testing" *ngIf="User.IsDeveloper">
        <app-email-test></app-email-test>
    </mat-tab>
</mat-tab-group>


// WEBPACK FOOTER //
// ./src/app/admin-settings/admin-settings.component.html